module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/.store/core-js@2.6.12/~/core-js/modules/_library.js
// module id = 92
// module chunks = 75